import React from "react";
import Card from "react-bootstrap/Card";




function MissionCard() {

    
  
  return (
    <Card className="policy-card mission-card">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p className="about-text">
            At Choicest Fruit<span className="small-r-symbol">®</span>, we believe that every person, regardless of age, background, or capacity, has something vital to contribute to the betterment of our communities.
            By drawing on the knowledge, experience, and creativity of local people, we generate solutions, share learning, and respond to challenges quickly and effectively. In this way, we tap into the collective skills, expertise, and resources of communities to create lasting impact.
          </p>

          <p className="about-text">
            Our mission is simple yet profound: to build vibrant communities. We do this by empowering individuals with the skills and confidence to actively participate in the technology-driven world around them.
            Through our programs, we aim to bridge the digital divide, ensuring that everyone has the opportunity to thrive in an increasingly tech-centric society.
          </p>

          <p className="about-text">
            A vibrant community is one where both the moral and material progress of all members is nurtured, and where everyone feels a true sense of belonging and purpose. To achieve this, we are committed to:
          </p>

          <ul className="mission-bullets">
            <li>
              <b className="purple">Developing individual and collective capacities for service</b>
            </li>
            <li>
              <b className="purple">Fostering genuine friendships rooted in mutual support and cooperation</b>
            </li>
            <li>
              <b className="purple">Creating opportunities for meaningful participation across generations</b>
            </li>
          </ul>

          <p className="about-text">
            This mission is carried forward not only by our programs, but by our Ambassadors. These individuals, trained through Choicest Fruit initiatives, accompany others in community-building efforts, multiplying impact by mentoring and empowering new leaders. Together, they strengthen the bonds of trust, purpose, and resilience in their communities.
          </p>         

          <p className="about-text">
           We recognize the challenges of our time: rising tensions, deep divisions, and the persistent stains of injustice, racial prejudice and technological inequality. In the face of this, Choicest Fruit is committed to reshaping society around the principles of justice, ethics, inclusivity, and reciprocity. Through our Ethical Tech Development Process, we work to ensure that innovation and progress serve humanity rather than divide it.
           Our mission is not only to imagine a better world, but to actively build it, one community, one friendship, one act of service at a time.

          </p>
      
          
          {/* <footer className="blockquote-footer"></footer> */}
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default MissionCard;
